module.exports = __webpack_public_path__ + "img/flac.86f7bb8c.svg";